import classNames from '@/lib/misc/classNames';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { GoArrowSwitch } from 'react-icons/go';
import { PiHouseLine } from 'react-icons/pi';
import { useMixpanel } from '@/lib/misc/mixpanel';
import { useSession } from '@/contexts/LitSessionProvider';
import useIsPWA from '@/hooks/utilities/useIsPWA';
import { AiOutlinePieChart } from 'react-icons/ai';
import { SlFeed } from 'react-icons/sl';
import { useFollowersQuery } from '@/hooks/following/useFollowing';
import useGetUserProfileInfo from '@/hooks/auth/useGetUserProfileInfo';
import { useLocalStorage } from 'usehooks-ts';
import { CgUserAdd } from 'react-icons/cg';
import { useTouchHandlerName } from '@/hooks/utilities/use-mobile';
interface MobileMenuProps {
  path?: string;
  className?: string;
  hasShadow?: boolean;
}
const MobileMenu: FC<MobileMenuProps> = ({
  path,
  className,
  hasShadow
}) => {
  const router = useRouter();
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const {
    PKP
  } = useSession();
  const isPWA = useIsPWA();
  const {
    userName
  } = useGetUserProfileInfo();
  const {
    data: allFollowersData
  } = useFollowersQuery({
    username: userName
  });
  const allFollowers = allFollowersData?.filter((x, idx) => {
    //remove duplicates
    return allFollowersData.findIndex(y => y.username === x.username) === idx;
  });
  const incomingRequests = allFollowers?.filter(x => x.status === 'pending');
  const [disableSwap, setDisableSwap] = useLocalStorage('disableSwap', false);
  const NAV_ITEMS = [{
    name: 'Home',
    icon: <PiHouseLine size={16} />,
    path: '/home',
    mixpanelName: 'goToHome'
  }, {
    name: 'Feed',
    icon: <CgUserAdd size={17} />,
    path: '/home?mode=feed',
    mixpanelName: 'goToFeed'
  }, {
    name: 'Trade',
    icon: <GoArrowSwitch size={16} />,
    path: '/home?mode=trade',
    mixpanelName: 'goToTrade'
  }, {
    name: 'Portfolio',
    icon: <AiOutlinePieChart size={20} />,
    path: '/home?mode=portfolio',
    mixpanelName: 'goToPortfolio'
  }].filter(x => {
    if (x.name == 'Trade' && disableSwap) {
      return false;
    }
    return true;
  });
  const isActive = (navPath: string) => {
    if (navPath === '/home') {
      return (router.pathname === '/home' || router.pathname === '/assets' || router.pathname === '/saved' || router.pathname === '/asset' || router.pathname === '/security' || router.pathname === '/wallets' || router.pathname === '/settings/settings') && !router.asPath?.includes('trade') && !router.asPath?.includes('portfolio') && !router.asPath?.includes('feed');
    }
    if (navPath?.includes('portfolio')) {
      return router.asPath?.includes('portfolio');
    }
    if (navPath?.includes('trade')) {
      return router.asPath?.includes('trade');
    }
    return router.asPath?.includes(navPath);
  };
  const touchHandlerName = useTouchHandlerName();
  console.log('touchHandlerName', touchHandlerName);
  return <div className='bg-genius-indigo  h-[70px]' data-sentry-component="MobileMenu" data-sentry-source-file="MobileMenu.tsx">
      <div style={{
      zIndex: 2000
    }} className={classNames(`fixed bottom-0 w-full flex h-[70px] px-[10%] bg-genius-indigo justify-between m-auto right-0 left-0 items-center lg:hidden ${hasShadow && 'top-shadow'}  ${isPWA ? 'pt-8 pb-10' : 'pb-0'}  `, className)}>
        {NAV_ITEMS.map(navItem => <div key={`mobile-${navItem.path}`} className={`flex relative items-center h-[46px] cursor-pointer rounded-lg ta-c gap-1 w-1/3 max-w-[100px] text-xs ${isActive(navItem.path) ? 'bg-genius-pink text-genius-indigo' : 'bg-genius-indigo text-primary'}
          `} {...{
        [touchHandlerName]: () => {
          LogToMixpanel({
            pkp: PKP,
            eventName: EVENTS.home[navItem.mixpanelName],
            category: CATEGORIES.home,
            metaData: {
              source: 'mobile'
            }
          });
          router.push(navItem.path);
        }
      }}>
            {incomingRequests?.length ? <>
                {' '}
                {navItem.name == 'Feed' && <div className='text-xs absolute top-1 right-3 bg-genius-pink text-genius-blue rounded-full w-auto px-1 h-4 flex items-center justify-center'>
                    {/* {m == 'Followers' && followers?.length} */}
                    {incomingRequests?.length}
                  </div>}
              </> : <> </>}

            <span className='m-auto'>{navItem.icon}</span>
          </div>)}
      </div>
    </div>;
};
export default MobileMenu;